import { UserDTO } from "@app/features/users/models/user.model";
import { Page } from "@app/shared/models/page.model";
import { BadgeVariant } from "@pansa/ui";

export interface GroupDTO {
  id: string;
  name: string;
  groupValue: string;
  group: string;
  createdAt: Date;
  responsibleUnit: string;
  usersCount?: number;
  webRqaUsers: UserDTO[];
}

export interface PageGroupDTO extends Page {
  content: GroupDTO[];
}

export interface GroupUserDTO {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  enabled: boolean;
}

export interface CreateGroupDTO {
  name: string;
  group: string;
  users?: string[];
  responsibleUnit: string;
}

export interface UpdateGroupDTO {
  id: string;
  name: string;
  group: string;
  responsibleUnit: string;
  users?: string[];
}

export interface RemoveUserFromGroupDTO {
  groupId: string;
  username: string;
}

export enum GroupTypeEnum {
    CIVIL = 'CIVIL',
    MILITARY = 'MILITARY',
    FMP = 'FMP',
    TECH = 'TECH'
}


export const GroupTypeColors: Record<GroupTypeEnum, BadgeVariant> = {
  [GroupTypeEnum.CIVIL]: 'light-blue',    
  [GroupTypeEnum.MILITARY]: 'purple',
  [GroupTypeEnum.FMP]: 'orange',
  [GroupTypeEnum.TECH]: 'pink'
};
